export default {
  UPDATE_PROJECT_CLONED: 'UPDATE_PROJECT_CLONED',
  RESET_PROJECT_CLONED: 'RESET_PROJECT_CLONED',
  CLONE_PROJECT_REQUEST: 'CLONE_PROJECT_REQUEST',
  CLONE_PROJECT_SUCCESS: 'CLONE_PROJECT_SUCCESS',
  CLONE_PROJECT_FAILURE: 'CLONE_PROJECT_FAILURE'
}
